<template>
	<div 
		:class="chartClasses"
		:style="style"
		:id="`chart--${index}`"
		>
	    <div class="Card__inner">
	        <div class="Card__header"
	        	:class="class"
	        	
	        	>
	            <div>
	                <h4 class="Card__header-title">{{ chartData.post.label ? chartData.post.label : chartData.title }}</h4>
	                <tippy v-if="tooltipEnabled">
	                    <button 
	                    	data-tippy-content 
	                    	class="tooltip-btn" 
	                    	:aria-labelledby="`chart-tooltip-${chartData.post.id}`"
	                    	
	                    	>i</button>
	                    	<template #content :class="chart-tooltip" >
						       	{{ chartData.post.tooltip_text }}
						    </template>
	                </tippy>
	            </div>
	            <template v-if="hasData">
		            <ChartFiltersComponent 
		            	:chartData="chartData"
		            	:feTheme="feTheme"
		            	:dropdownFilters="dropdownFilters"
		            	:dateFilters="dateFilters"
		            	@filtersSubmit="filtersSubmit"
	            	/>
        		</template>
            	
	        </div>
		        <a 
			    	v-if="chartData.type == 'number_card' && chartData.schema.linked_component.enabled"
			    	:href="chartData.schema.linked_component.url" 
			    	class="Card__content format-content"
			    	>
			    	<component 
			    			:hasData="hasData"
	        				:is="chartComponent"
		        			:data="data.data"
		        			:chartData="data"
		        			:options="options"
		        			:plugins="plugins"
		        			:feTheme="feTheme"
		        			:tooltipDefaultConfig="tooltipDefaultConfig"
	        			/>
		    	</a>

	        	<div v-else class="Card__content format-content">
	        		<component 
        					:hasData="hasData"
	        				:is="chartComponent"
		        			:data="data.data"
		        			:chartData="data"
		        			:options="options"
		        			:plugins="plugins"
		        			:feTheme="feTheme"
		        			:tooltipDefaultConfig="tooltipDefaultConfig"
	        			/>
	            </div>        
	        <!-- {% block format %}{% endblock %} -->
	    </div>
	</div>

</template>

<script>

import moment from 'moment'
import { compress, decompress } from '@amoutonbrady/lz-string'

import ChartFiltersComponent from '@vueapp/components/charts/ChartFiltersComponent.vue'

import AreaChartStacked from '@vueapp/components/charts/AreaChartStacked.vue'
import BarChart from '@vueapp/components/charts/BarChart.vue'
import BarChartSimple from '@vueapp/components/charts/BarChartSimple.vue'
import BarChartStacked from '@vueapp/components/charts/BarChartStacked.vue'
import BarLineChart from '@vueapp/components/charts/BarLineChart.vue'
import DoughnutChart from '@vueapp/components/charts/DoughnutChart.vue'
import HistogramChart from '@vueapp/components/charts/HistogramChart.vue'
import LineChart from '@vueapp/components/charts/LineChart.vue'
import LineChartCompound from '@vueapp/components/charts/LineChartCompound.vue'
import NumberCard from '@vueapp/components/charts/NumberCard.vue'
import PieChart from '@vueapp/components/charts/PieChart.vue'
import RadarChart from '@vueapp/components/charts/RadarChart.vue'

export default {
	name: 'ChartComponent',
	props: {
		index: String,
		chartData: Object,
		chartClass: String
	},
	components: { 
		AreaChartStacked,
		BarChart,
		BarChartSimple,
		BarChartStacked, 
		BarLineChart,
		DoughnutChart,
		HistogramChart,
		LineChart,
		LineChartCompound, 
		NumberCard, 
		PieChart, 
		RadarChart,

		ChartFiltersComponent
	},
	data() {
		return {
			ls_id: `originalData_${this.index}`,
			originalData: {}, //JSON.parse( JSON.stringify( this.chartData ) ),
			data: this.chartData,
			schema: this.chartData.schema,
			tooltipDefaultConfig: {
				padding: 10,
				borderWidth: 0,
				cornerRadius: 0,
				bodySpacing: 10,
				titleFont: {
					size: 14
				},
				bodyFont: {
					size: 14
				},
			}
		}
	},
	created() {
        // if(this.chartData.title === 'Vorgänge') {
        //     console.log('this.chartData::', this.chartData)
        // }

		// this.originalData = { ...this.chartData.data }
        // if(this.index === '722_7_0') {
        //     console.log(this.ls_id, this.chartData.data);
        // }

        if(this.chartData.period) {
            const startTimeStamp = this.chartData.options.minDate * 1000 ?? false,
                endTimeStamp = this.chartData.options.maxDate * 1000 ?? false;

            if (startTimeStamp && endTimeStamp) {
                const pastFakeDates = this.generateFakeDates(startTimeStamp, 120, this.chartData.period, 'past'),
                    futureFakeDates = this.generateFakeDates(endTimeStamp, 120, this.chartData.period, 'future');

                // if(this.chartData.title === 'Vorgänge') {
                //     console.log(this.chartData.period)
                // }

                let that = this;
                that.chartData.data.datasets.forEach((item, key) => {
                    that.chartData.data.datasets[key].data.unshift( ...pastFakeDates );
                    that.chartData.data.datasets[key].data.push( ...futureFakeDates );
                })


            }
        }

		localStorage.setItem( this.ls_id, compress(JSON.stringify(this.chartData.data)));
	},
	mounted() {
		const _this = this,
			data = this.chartData.data,
			options = this.chartData.options


        // console.log('this.data.options.minDate:: ',this.data.options)
		const config = {
			type: 'doughnut',
			data,
			options: {
				responsive: true,
				maintainAspectRatio: false,
				legend: {
					position: 'right',
				},

				events: ['click', 'mousemove', 'mouseout'],
				onClick(e, a) {
					if ( _this.schema.linked_component.enabled ) {
						document.location.href = _this.schema.linked_component.url + '?' + '?soft-filter[' + _this.schema.linked_component.url_key_name + ']=' + e.chart.data.labels[a[0].index] + '&env=' + _this.schema.linked_component.env
					}
					return
				},
				plugins: {
					tooltip: {
						..._this.tooltipDefaultConfig,
						enabled: options.labels_type == 'tooltip',
						callbacks: {
							label: function(ctx) {
								let sum = 0;
								let dataArr = ctx.chart.data.datasets[0].data;

								dataArr.map(data => {
									sum += parseInt(data.value);
								});

								let val = options.labels_scale == 'percentage' ?(ctx.dataset.data[ctx.dataIndex] * 100 / sum).toFixed(2) + '%' : ctx.dataset.data[ctx.dataIndex].value;

								let label = ' ' + ctx.label +
									' ' + val || '';

								return label;
							}
						}
					},
					datalabels: {
						display: options.labels_type == 'datalabel',
						formatter: (value, ctx) => {
							let sum = 0;
							let dataArr = ctx.chart.data.datasets[0].data;

							dataArr.map(data => {
								sum += parseInt(data.value);
							});

							let percentage = (value.value*100 / sum).toFixed(2)+"%";

							let result = options.labels_scale == 'percentage' ? percentage : ctx.chart.data.datasets[0].data[ctx.dataIndex].value;

							return (result != '0.00%' && result != '0') ? result : ''

						},
						color: '#fff',
					},
				}
			},
			plugins: [ this.beforeInit ]
		};
	},
	methods: {
        generateFakeDates(timestamp, numberOfMonths, period = 'month', type = 'future') {
            const dates = [];

            let unit;
            if(period === 'daily') {
                unit = 'days';
            } else if(period === 'weekly') {
                unit = 'weeks';
            } else if(period === 'yearly') {
                unit = 'years';
            } else {
                unit = 'months'
            }

            // let date = moment(timestamp);
            for (let i = 1; i < numberOfMonths; i++) {
                const date = moment(timestamp);

                // Adjust the date based on the period
                if(type === 'past') {
                    date.subtract(i, unit);
                } else {
                    date.add(i, unit);
                }

                const obj = { x: date.format('YYYY-MM-DD'), y: 0, items: [] };

                dates.push(obj);

            }

            let result = [];
            if(type === 'past') {
                result = dates.reverse();
            } else {
                result = dates;
            }

            return result;
        },
		filtersSubmit(filters) {
			// console.log('filtersSubmit::filtersSubmit()', filters )
			// this.$emit('refresh', {filters, sorting})

			const _this = this

			if (filters) {

				const originalDatasets = [ ...this.data.data.datasets ],
					originalData = { ...this.data.data }
				const datasets = this.data.data.datasets

                console.log(originalData)

				// let filteredData = this.chartData.data

				// Retrieve the object from storage
				const retrievedObject = JSON.parse( decompress(localStorage.getItem( this.ls_id )) )
				let xDates = []
				for ( let fkey in filters ) {
					//temp
					let key = fkey == 'time-interval' ? 'created_at' : fkey
					let type = fkey == 'time-interval' ? 'date' : 'other',
						value = filters[fkey]

					// alert(fkey + ' ' + key + ' ' + value)
					

					originalData.datasets = retrievedObject.datasets.map( ( dataset, dsIndex ) => {
						let result = dataset
						
						if ( !value 
								|| 'date' == type && Array.isArray(value) && ( ! value[0] || ! value[1] )
							) return result;

						/*
						 * If date_filter_column is used
						 */

                        // console.log('type::', type)

						if ( type && type === 'date' ) {
							// const startDate = value[0];
							// const endDate = value[1];
							const format = 'YYYY-MM-DDTHH:mm:ss.SSSSZ'
							const dates = value.split('|')
							const startDate   = moment.unix(dates[0]).format(format)
							const endDate     = moment.unix(dates[1]).format(format)

                            //Change the dates on x-axis
                            this.data.options.minDate = dates[0];
                            this.data.options.maxDate = dates[1];

							result.data = dataset.data.map( (data, index) => {
								if ( data.y > 0 ) {
									data.items = data.items.filter( item => {
										const compareDate = moment(item[key], format);
										const isDateWithinInterval = compareDate.isBetween(startDate, endDate);
										// console.log(isDateWithinInterval)
										if(isDateWithinInterval) {
											xDates.push( item[_this.schema.column_name_x] )
											return item;
										} else {
											data.y -= 1;
										}
									})
								} else if ( data.data ) {
									data.data = data.data.filter( item => {
										const compareDate = moment(item[key], format);
										const isDateWithinInterval = compareDate.isBetween(startDate, endDate);

										if(isDateWithinInterval) {
											xDates.push( item[_this.schema.column_name_x] )
											return item;
										} else {
											data.value -= 1;
										}
									});
								}

								return data
							})

							return result

						/*
						 *	Else if we have dates on the x-axis
						 */
						} else {
							result.data = dataset.data.map( (data, index) => {
								if ( data.y > 0 ) {
									data.items = data.items.map( item => {
										if ( item[key] !== value ) {
											if ( 'percentage' == this.chartData.options.y_axis ) {
												let y_real_new  = data.y_real > 1 ? data.y_real - 1 : 0
												data.y = ( 0 == data.y_real ) ? 0 : ( y_real_new * data.y ) / data.y_real
												data.y_real = y_real_new
											} else {
												data.y -= 1
											}
										} else {
											
											return item
										}
									})
								} else if(data.value > 0) {
									data.data = data.data.map( item => {
										if ( item[key] !== value ) {
											data.value -= 1
										} else {
											return item
										}
									})
								}

								return data
							})

							return result
						}
					})
					this.data.data = originalData
				}
				// xDates = xDates.map( item => {
				// 	return moment(item, 'YYYY-MM-DD')
				// })
				// const format = 'YYYY-MM-DDTHH:mm:ss.SSSSZ'
				// console.log('xDates::', xDates, moment.max(xDates).format(format), moment.min(xDates).format(format) )
				// this.data.options.maxDate = moment.max(xDates).valueOf() / 1000 //format(format)
				// this.data.options.minDate = moment.min(xDates).valueOf() / 1000 //format(format)

				// console.log('Options::', this.data.options)
			}
		}
	},
	computed: {
		hasData() {
			// console.log('hasData()::', this.chartData.data.datasets, !this.chartData.data.datasets, !!this.chartData.data.datasets)
			return !!this.chartData.data.datasets && !!this.chartData.data.datasets.length
		},
		computedChartData() {
			this.data = { ...this.chartData }
			return this.data
		},
		feTheme() {
            // console.log('fe_theme::', window.fe_theme)
            return window.fe_theme 
        },

        class() {
        	return (this.chartData.post.dropdown_filters && this.chartData.post.dropdown_filters != 0) 
        		|| this.chartData.post.date_filter || this.chartData.post.tooltip_text ? 'filters-are-enabled' : ''
        },

        style() {
        	if ( this.chartData.options.colors && this.chartData.options.colors.bg_color && this.chartData.options.colors.text_color ) {
        		return `--bg-color: ${this.chartData.options.colors.bg_color};--text-color: ${this.chartData.options.colors.text_color}`
        	}
        	return 1
        },

        tooltipEnabled() {
        	return !!this.chartData.post.tooltip_enabled && this.chartData.post.tooltip_enabled != 0
        },

        dropdownFilters() {
			return ( this.chartData.filters.table_filters && this.chartData.filters.table_filters.length ) ? this.chartData.filters.table_filters : []
        },

        dateFilters() {
            // if(this.chartData.title === 'Vorgänge') {
            //     console.log('dateFilters()', this.chartData.filters.date_filters)
            // }
			return this.chartData.filters.date_filters
        },

		chartComponent() {
			const chartTypes = {
				'number_card' : 'NumberCard',
				'doughnut_chart' : 'DoughnutChart',
				'barchart-stacked' : 'BarChartStacked',
				'piechart' : 'PieChart',
				'linechart' : 'LineChart',
				'barline_chart' : 'BarLineChart',
				'barchart-simple' : 'BarChartSimple',
				'barchart' : 'BarChart',
				'linechart_compound' : 'LineChartCompound',
				'areachart_stacked' : 'AreaChartStacked',
				'radar_chart' : 'RadarChart',
			}
			return chartTypes[ this.chartData.type ]
		},
		chartClasses() {
			return `Card Card--small elevation-1 ${this.chartClass} column-${this.chartData.column_ratio} row-span-${this.chartData.row_span} ${this.chartClass ?? '' } ${ this.chartData.type == 'number_card' ? 'Card--number' : 'Card--' + this.chartData.type }`
		},
		options() {
			const configOptions = this.data.options,
				_this = this
			return {
				responsive: true,
				maintainAspectRatio: false,
				legend: {
					position: 'right',
				},
				plugins: {
					tooltip: {
						...this.tooltipDefaultConfig,
						enabled: configOptions.labels_type == 'tooltip',
						callbacks: {
							label: function(ctx) {
								let sum = 0;
								let dataArr = ctx.chart.data.datasets[0].data;

								dataArr.map(data => {
									sum += parseInt(data.value);
								});

								let val = configOptions.labels_scale == 'percentage' ?(ctx.dataset.data[ctx.dataIndex] * 100 / sum).toFixed(2) + '%' : ctx.dataset.data[ctx.dataIndex].value;

								let label = ' ' + ctx.label +
									' ' + val || '';

								return label;
							}
						}
					},
					datalabels: {
						display: configOptions.labels_type == 'datalabel',
						formatter: (value, ctx) => {
							let sum = 0;
							let dataArr = ctx.chart.data.datasets[0].data;

							dataArr.map(data => {
								sum += parseInt(data.value);
							});

							let percentage = (value.value*100 / sum).toFixed(2)+"%";

							let result = configOptions.labels_scale == 'percentage' ? percentage : ctx.chart.data.datasets[0].data[ctx.dataIndex].value;

							return (result != '0.00%' && result != '0') ? result : ''

						},
						color: '#fff',
					},
				},
				events: ['click', 'mousemove', 'mouseout'],
				onClick(e, a) {
					if ( _this.schema.linked_component.enabled ) {
						document.location.href = _this.schema.linked_component.url + '?' + '?soft-filter[' + _this.schema.linked_component.url_key_name + ']=' + e.chart.data.labels[a[0].index] + '&env=' + _this.schema.linked_component.env
					}
					return;
				}
			}
		},
		plugins() {
			
			return [
				{
					beforeInit: function(chart, options) {
						// Get reference to the original fit function
						const originalFit = chart.legend.fit;

						// Override the fit function
						chart.legend.fit = function fit() {
							// Call original function and bind scope in order to use `this` correctly inside it
							originalFit.bind(chart.legend)();
							// Change the height as suggested in another answers
							this.height += 10;
						}
					}
				}
			]
		}
	}
}
</script>